export default __webpack_public_path__ + "static/media/pizza.7db3831f.png";